<template>
  <div>
    <div class="rpg-pd-5-10 rpg-bd-b">
      <label class="rpg-label">人选意向：</label>
      <el-radio v-model="formData.意向" label="非常积极">非常积极</el-radio>
      <el-radio v-model="formData.意向" label="积极">积极</el-radio>
      <el-radio v-model="formData.意向" label="犹豫">犹豫需要推动</el-radio>
    </div>
    <Pipeidu ref="Pipeidu" :radish="radish" :project="project"></Pipeidu>
    <div class="rpg-pd-5-10 rpg-bd-b">
      <label class="rpg-label">推荐度：</label>
      <el-radio v-model="formData.推荐度" label="重点推荐">重点推荐</el-radio>
      <el-radio v-model="formData.推荐度" label="一般推荐">一般推荐</el-radio>
      <el-radio v-model="formData.推荐度" label="不作为重点推荐">不作为重点推荐</el-radio>
    </div>
    <div class="rpg-pd-5-10 rpg-bd-b">
      <div class="rpg-label">诉求：</div>
      <el-input type="textarea" rows="3" v-model="formData.诉求"></el-input>
    </div>
    <div class="rpg-pd-5-10 rpg-bd-b">
      <div class="rpg-label">提醒选项：</div>
      <div>
        <span>固定提醒(不可更改)：</span>
        <span class="rpg-gray">
          项目经理：{{ (project.项目经理 || []).toString() }} 客户开发：{{ (project.客户开发 || []).toString() }}
        </span>
      </div>
      <div>
        <span>添加提醒：</span>
        <el-select v-model="formData.otherTo" multiple filterable size="mini" placeholder="选择提醒对象">
          <el-option v-for="(item, k) in users" :key="k" :label="item" :value="item"> </el-option>
        </el-select>
      </div>
    </div>
    <div class="rpg-pd-5-10 rpg-text-center">
      <el-button size="mini" type="primary" @click="handleConfirm">提交</el-button>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')
import Pipeidu from './pipeidu'
export default {
  components: { Pipeidu },
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      formData: {
        意向: '非常积极',
        推荐度: '重点推荐',
        诉求: '',
        otherTo: [],
      },
      users: [],
    }
  },
  async mounted() {
    if (!app.accounts) {
      await app.getUsers()
    }
    this.users = app.accounts
  },
  methods: {
    async handleConfirm() {
      let recentStatus = []
      const rid = this.radish.rid || this.radish._id
      const res = await app.service('radish').getRadishRecentStatus({ rid })
      if (res && res.status === 'success') {
        recentStatus = res.data.filter(rs => rs.顾问 !== account)
      }
      const account = app.user.account
      if (recentStatus && recentStatus.length > 0) {
        const msg = recentStatus.reduce(
          (str, rs) => str + `人选${rs.候选人}已于${dateFormat(rs.确认时间 || rs.createdAt, 'yyyy年mm月dd日')}进入 ${rs.客户公司}-${rs.项目名称} 项目的${rs.类型}，推荐前建议您与推荐顾问 ${this.formatName(rs.顾问)} 就人选最新状态进行沟通。`,          ''
        )
        this.$confirm(msg, '提示', {
          confirmButtonText: '忽略继续推荐',
          cancelButtonText: '取消推荐',
          type: 'warning'
        }).then(async () => {
          const ac = recentStatus.map(rs => rs.顾问).filter(rs => rs)
          const msg2 = `为了避免冲突，在您完成推荐动作之后，系统将会通知 ${ac.map(a=>this.formatName(a)).join('、')}。是否确认继续推荐。`
          this.$confirm(msg2, '提示', {
            confirmButtonText: '确认推荐',
            cancelButtonText: '取消推荐',
            type: 'warning'
          }).then(async () => {
            // 通知相关顾问
            for (let i = 0; i < recentStatus.length; i++) {
              const item = recentStatus[i]
              const notify = {
                title: `您最近${item.类型}的人选${item.候选人}被推荐`,
                type: '人选',
                action: '被人推荐',
                content: `您最近【${item.类型}】的人选【${item.候选人}】被顾问【${this.formatName(account)}】推荐了`,
                rid: item.rid,
              }
              await app.service('notify').addNotify({
                notify,
                to: ac,
              })
            }
            this.doConfirm()
          }).catch(() => {})
        }).catch(() => {})
      } else {
        this.doConfirm()
      }
    },
    async doConfirm() {
      const rid = this.radish.rid || this.radish._id
      const pid = this.project._id
      const param = Object.assign({ rid, pid }, this.formData)
      const res = await app.service('radish').addRecommend(param)
      if (res.status == 'success') {
        await this.$refs.Pipeidu.handleConfirm()
        this.onConfirm()
        this.$message.success('推荐成功')
        this.formData = {
          意向: '非常积极',
          推荐度: '重点推荐',
          诉求: '',
          otherTo: [],
        }
        // app.root.$refs.RecommendAuthorization.open({pid,rid})
      } else {
        this.$message.error(res.msg)
      }
    },
    formatName(account) {
      const user = app.users.find(u => u.account === account)
      return user ? `${user.姓名}${user.account}`: account
    },
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
